.anchorNav {
  align-self: flex-start;
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex: 0 0 237px;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-4) 0;
  position: sticky;
  top: var(--pgm-sys-spacing-6);
  width: 237px;
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.list {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
}

.link {
  border-radius: 20px;
  color: var(--pgm-sys-color-primary);
  display: block;
  padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-4);
  text-decoration: none;
}

.link:hover,
.link:focus {
  background-color: var(--pgm-sys-color-surface-container-low);
  color: var(--pgm-sys-color-primary);
  text-decoration: none;
}

.link:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: 2px;
}

@media (max-width: 991.98px) {
  .anchorNav {
    display: none;
  }
}
